import React from 'react';
import AddLead from '../components/AddLead';

function AddLeadPage() {
  return (
    <AddLead/>
  );
}

export default AddLeadPage;